export default "__VITE_ASSET__D99hp91B__"